








export default {
  name: 'connexion-check',
  data() {
    return {
      online: true
    }
  },
  created() {
    if (window.navigator === undefined || window.navigator.onLine === undefined) return
    document.addEventListener('online', () => {
      this.online = true
    }, false)
    document.addEventListener('offline', () => {
      this.online = false
    }, false)
    this.online = window.navigator.onLine
  }
}



// WEBPACK FOOTER //
// ./src/components/connexion-check.vue